import {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import {
  loginAnalyticsTracking,
  TRACKING_ACTIONS,
  TRACKING_ERROR_CODES,
  TRACKING_TYPES,
  trackSysConnect,
} from "~/app/services/scopely/loginAnalyticsTracking";
import ScopelyIcon from "~/assets/icons/scopely_logo_small.svg";
import {scopelyId} from "~/services/scopely/scopelyId";
import {useAuthStore} from "~/stores/auth";
import {LoginButton} from "./LoginButton";
import {LoginIdentityOperation} from "@scopely/web-sdk-scopelyid";

export function LoginWithScopely() {
  const {t} = useTranslation();

  const {setAccountLogin} = useAuthStore();

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = useCallback(async () => {
    setIsLoading(true);
    setAccountLogin("scopely");

    try {
      const scopelyIdInitialized = await scopelyId;
      await scopelyIdInitialized?.login({
        operation: LoginIdentityOperation.Login
      });
    } catch (err) {
      loginAnalyticsTracking({
        type: TRACKING_TYPES.SCOPELY_ID,
        action: TRACKING_ACTIONS.LOGIN_ABANDONED,
      });
      trackSysConnect({
        type: "ScopelyId",
        errorCode: `${TRACKING_ERROR_CODES.UNKNOWN_ERROR}`,
      })
      setIsLoading(false);
      // biome-ignore lint: for debugging
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [setAccountLogin]);

  return (
    <LoginButton
      onClick={handleClick}
      disabled={isLoading}
      data-testid="scopely-btn"
      startIcon={
        <img
          src={ScopelyIcon}
          style={{width: "24px", height: "24px", flex: "1 0 24px"}}
          alt="Scopely Logo"
        />
      }
      sx={{
        justifyContent: "start",
        backgroundColor: "#00047D",
        "&:hover": {
          backgroundColor: "#0a10c0",
        },
      }}
    >
      {t("sign.scopely")}
    </LoginButton>
  );
}
